import { render, staticRenderFns } from "./sideexpert.vue?vue&type=template&id=0bfe4d23&scoped=true&"
import script from "./sideexpert.vue?vue&type=script&lang=js&"
export * from "./sideexpert.vue?vue&type=script&lang=js&"
import style0 from "./sideexpert.vue?vue&type=style&index=0&id=0bfe4d23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe4d23",
  null
  
)

export default component.exports